import { DateDisplay } from "../DateDisplay";
import { Emdash } from "../Punctuation";
import { Tooltip } from "../Tooltip";
import { DataGridDollarValue } from "./DataGridDollarValue";
import { DataGridPercentValue } from "./DataGridPercentValue";
import { ColumnType, ColumnTypes, RowSize } from "./types";
import React from "react";
import { DataGridYearValue } from "./DataGridYearValue";
import { DataGridPercentChangeValue } from "./DataGridPercentChangeValue";
import { DatetimeDisplay } from "../DateDisplay";
import { TimeAgoDisplay } from "../DateDisplay/TimeAgoDisplay";
import { DatetimeCompactDisplay } from "../DateDisplay/component";

// // // //

export function DataGridCellVal(props: {
    value: string | number | null | undefined;
    size: RowSize;
    type: ColumnType;
}) {
    const { value, type } = props;

    if (type === ColumnTypes.string) {
        if (value === undefined || value === null) {
            return <Emdash />;
        }
        return <>{value}</>;
    }

    if (type === ColumnTypes.name) {
        if (value === undefined || value === null || value === "") {
            return <Emdash />;
        }
        return <>{value}</>;
    }

    if (type === ColumnTypes.date) {
        return <DateDisplay value={value as string} />;
    }

    if (type === ColumnTypes.datetime) {
        return <DatetimeDisplay value={value as string} />;
    }

    if (type === ColumnTypes.datetimeCompact) {
        return <DatetimeCompactDisplay value={value as string} />;
    }

    if (type === ColumnTypes.timeAgo) {
        if (value === undefined || value === null || value === "") {
            return <Emdash />;
        }

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="w-max px-2 py-1 text-center">
                        <p className="whitespace-nowrap text-sm font-light">
                            <DatetimeDisplay value={value as string} />
                        </p>
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span
                        ref={setTriggerRef}
                        className="cursor-default text-slate-700"
                    >
                        <TimeAgoDisplay value={value as string} />
                    </span>
                )}
            </Tooltip>
        );
    }

    if (type === ColumnTypes.number) {
        if (
            value === undefined ||
            value === null ||
            typeof value !== "number" ||
            Number.isNaN(value)
        ) {
            return <Emdash />;
        }

        if (typeof value === "number") {
            return <>{value.toLocaleString()}</>;
        }

        return <>{value}</>;
    }

    if (type === ColumnTypes.dollar) {
        if (
            value === undefined ||
            value === null ||
            typeof value !== "number" ||
            Number.isNaN(value)
        ) {
            return <Emdash />;
        }
        return <DataGridDollarValue value={value as number} />;
    }

    if (type === ColumnTypes.token) {
        if (
            value === undefined ||
            value === null ||
            typeof value !== "number" ||
            Number.isNaN(value)
        ) {
            return <Emdash />;
        }
        return (
            <>
                {value.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}
            </>
        );
    }

    if (type === ColumnTypes.percent) {
        return <DataGridPercentValue value={value as number} />;
    }

    if (type === ColumnTypes.years) {
        return <DataGridYearValue value={value as number} />;
    }

    if (type === ColumnTypes.percentChange) {
        return <DataGridPercentChangeValue value={value as number} />;
    }

    return null;
}

export const DataGridCellValue = React.memo(DataGridCellVal);
